import { connect } from "react-redux";
import ViewPocs from "./viewPocs";
import { bindActionCreators } from "redux";
import {
  getPocListing,
  updatePocStatus,
} from "services/redux/brandActivtion/pocListing/action";

const mapStateToProps = (state) => ({
  pocList: state.baPocListReducer.pocList,
  updateStatus: state.baPocListReducer.updatePocStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPocListing,
      updatePocStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewPocs);
